"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_DataRequirement = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_canonical_1 = require("../Scalar/RTTI_canonical");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_DataRequirement_CodeFilter_1 = require("./RTTI_DataRequirement_CodeFilter");
var RTTI_DataRequirement_DateFilter_1 = require("./RTTI_DataRequirement_DateFilter");
var RTTI_positiveInt_1 = require("../Scalar/RTTI_positiveInt");
var RTTI_DataRequirement_Sort_1 = require("./RTTI_DataRequirement_Sort");
exports.RTTI_DataRequirement = t.recursion('IDataRequirement', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        type: RTTI_code_1.RTTI_code,
        _type: RTTI_Element_1.RTTI_Element,
        profile: t.array(RTTI_canonical_1.RTTI_canonical),
        subjectCodeableConcept: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        subjectReference: RTTI_Reference_1.RTTI_Reference,
        mustSupport: t.array(t.string),
        _mustSupport: t.array(RTTI_Element_1.RTTI_Element),
        codeFilter: t.array(RTTI_DataRequirement_CodeFilter_1.RTTI_DataRequirement_CodeFilter),
        dateFilter: t.array(RTTI_DataRequirement_DateFilter_1.RTTI_DataRequirement_DateFilter),
        limit: RTTI_positiveInt_1.RTTI_positiveInt,
        _limit: RTTI_Element_1.RTTI_Element,
        sort: t.array(RTTI_DataRequirement_Sort_1.RTTI_DataRequirement_Sort)
    });
});
//# sourceMappingURL=RTTI_DataRequirement.js.map